/* cb-home-click.js — home-page click-through instrumentation (release 2026-09-26).
 *
 * Loaded ONLY on the home page (snippets/head_assets.liquid gates it on template.name == 'index').
 * For each qualifying click it publishes ONE event on the Shopify analytics bus:
 *
 *   Shopify.analytics.publish('home_click', { link_type, destination, section })
 *
 *   link_type    'collection' | 'pdp' - a link inside <main id="MainContent"> (home content)
 *                'nav'                - a link in site-navigation chrome: header, menu drawer,
 *                                       mobile bottom bar, footer
 *   destination  same-origin path, normalised: market/locale root, query and hash stripped;
 *                product links collapsed to /products/<handle> (collection context dropped)
 *   section      home section key for content clicks (the key in templates/index.json),
 *                else 'header' | 'menu_drawer' | 'mobile_bar' | 'footer'
 *
 * The event name and params are a byte-exact contract with the CRO-owned Custom Pixel that forwards
 * them to GA4 - see docs/tracking/home-click.md. Observe-only: it never calls preventDefault and never
 * delays navigation; everything is wrapped so a failure can only drop the event, never break the click.
 *
 * Not tracked: the cart drawer, the search drawer / predictive-search results, external or non-http
 * links, '#' and javascript: toggles, and content links to anything other than a collection or product.
 * The header is matched by section-id prefix so every header layout (inline / bottom / search /
 * categories / e-commerce) counts as nav - do not add header-search to SKIP: it is a full header layout.
 */
(function () {
  if (window.__cbHomeClick) return;
  window.__cbHomeClick = true;

  var SKIP = '#t4s-mini_cart, #t4s-search-hidden, #search-hidden, ' +
    '[id^="shopify-section-predictive-search"], [id^="shopify-section-ecom-predictive-search"]';

  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function normPath(u) {
    var p = u.pathname || '/', r = root();
    if (r !== '/' && p.indexOf(r) === 0) p = '/' + p.slice(r.length);
    var m = p.match(/\/products\/([^\/]+)/);
    if (m) return '/products/' + m[1];
    return p.length > 1 ? p.replace(/\/+$/, '') : p;
  }

  function sectionKey(el) {
    var s = el.closest('[id^="shopify-section-"]');
    if (!s) return 'unknown';
    var id = s.id.replace(/^shopify-section-/, ''), i = id.lastIndexOf('__');
    return (i >= 0 ? id.slice(i + 2) : id).slice(0, 40);
  }

  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.closest(SKIP)) return;
      var raw = a.getAttribute('href') || '';
      if (!raw || raw.charAt(0) === '#' || /^javascript:/i.test(raw)) return;
      var u = new URL(raw, location.href);
      if ((u.protocol !== 'https:' && u.protocol !== 'http:') || u.origin !== location.origin) return;
      var dest = normPath(u), type, section;
      if (a.closest('#MainContent')) {
        if (dest.indexOf('/products/') === 0) type = 'pdp';
        else if (/^\/collections(\/|$)/.test(dest)) type = 'collection';
        else return;
        section = sectionKey(a);
      } else if (a.closest('#t4s-footer')) { type = 'nav'; section = 'footer'; }
      else if (a.closest('#t4s-menu-drawer')) { type = 'nav'; section = 'menu_drawer'; }
      else if (a.closest('#shopify-mb_nav')) { type = 'nav'; section = 'mobile_bar'; }
      else if (a.closest('[id^="shopify-section-header"]')) { type = 'nav'; section = 'header'; }
      else return;
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('home_click', { link_type: type, destination: dest, section: section });
      }
    } catch (err) {}
  }, true);
})();
